import React from 'react';
import { Translate, withLocalize } from "react-localize-redux";
import classnames from 'classnames';

class AlertsExportLimitPopup extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className={classnames('alerts-export-limit-text has-text-centered', { 'is-normal': localStorage.locales_url_format === 'normal' })}>
                    <Translate id='Alerts.Excel.MaxRows' data={{ exportMax: this.props.exportMax, helpdesk: this.props.helpdesk }} options={{ renderInnerHtml: true }} />
                </div>
                <div className="modal-inner-buttons">
                    <button onClick={() => this.props.close()} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}>
                        <Translate id='Common.Button.Cancel' />
                    </button>
                </div>
            </React.Fragment>
        )
    }
}

export default withLocalize(AlertsExportLimitPopup);